module.exports = __webpack_public_path__ + "media/images/items/static-1-0299eed903ee71c8c953b7373afe977c.jpg";